import React from 'react';
import moment from 'moment';
moment.locale('es');
import 'moment/locale/es';
import FalconCloseButton from 'components/common/FalconCloseButton';
import { Modal } from 'react-bootstrap';
import ButtonClose from 'utils/buttons/ButtonClose';
import PropTypes from 'prop-types';
import { TablaPermisos } from './components/TablaPermisos';
import AlternativeModalButtonsContainer from 'sites/common/AlternativeModalButtonsContainer';

const ViewRol = ({ rol, closeModalView }) => {
  const handleClose = () => closeModalView();

  return (
    <Modal
      keyboard={true}
      show={true}
      onHide={handleClose}
      backdrop="static"
      centered
    >
      <Modal.Header>
        <Modal.Title>
          Detalles del rol <b>{rol.name}</b>
        </Modal.Title>

        <FalconCloseButton onClick={handleClose} />
      </Modal.Header>

      <Modal.Body className="px-4">
        <div>
          <Modal.Title className="mb-3 fs-2">Permisos:</Modal.Title>

          <TablaPermisos roleToPermission={rol.roleToPermission} />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <AlternativeModalButtonsContainer>
          <ButtonClose
            text="Cerrar"
            funcion={handleClose}
            variant="secondary"
          />
        </AlternativeModalButtonsContainer>
      </Modal.Footer>
    </Modal>
  );
};

ViewRol.propTypes = {
  rol: PropTypes.object.isRequired,
  closeModalView: PropTypes.func.isRequired
};

export default ViewRol;
